import { render, staticRenderFns } from "./InputInsertentity.vue?vue&type=template&id=2686718f&scoped=true"
import script from "./InputInsertentity.vue?vue&type=script&lang=js"
export * from "./InputInsertentity.vue?vue&type=script&lang=js"
import style0 from "./InputInsertentity.vue?vue&type=style&index=0&id=2686718f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2686718f",
  null
  
)

export default component.exports